import * as types from './types';

const initialState = {
  currentView: 2,
};

type FunnelAction = {
  type: typeof types[keyof typeof types];
  payload: number;
};

export default function funnelReducer(state = initialState, action: FunnelAction) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_VIEW':
      return { ...state, currentView: payload };
    default:
      return { ...state };
  }
}
